import script from "./BaseDropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDropzone.vue?vue&type=script&setup=true&lang=js"

import "./BaseDropzone.vue?vue&type=style&index=0&id=fc45923e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc45923e"]])

export default __exports__